import ObserveFontFace from "./ObserveFontFace";
import SetCSSProperties from "./SetCSSProperties";
import ShrinkHeaderOnScroll from "./ShrinkHeaderOnScroll";
import ToggleDrawer from "./ToggleDrawer";
import InitializeCustomerAnalytics from "./InitializeCustomerAnalytics";

export default {
  ObserveFontFace,
  SetCSSProperties,
  ShrinkHeaderOnScroll,
  ToggleDrawer,
  InitializeCustomerAnalytics,
};
